import React from "react";
import { twMerge } from "tailwind-merge";
import { Element } from "../base";

interface IProps {
    className?: string;
    children?: React.ReactNode;
}

export default function CardContent({ className, children, ...props }: IProps) {
    return (
        <Element
            {...props}
            className={twMerge("bm-card-content", className)}
        >
            {children}
        </Element>
    );
}
